module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-input",
    class: {
      'is-disabled': _vm.disabled,
      'has-icon': _vm.icon,
      'has-clear': !_vm.disabled && _vm.clear && _vm.dataValue
    }
  }, [_c('span', {
    staticClass: "input-wrap"
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.dataValue
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.$emit('change', $event)
      },
      "focus": function($event) {
        _vm.$emit('focus', $event)
      },
      "blur": function($event) {
        _vm.$emit('blur', $event)
      }
    }
  }), _c('vbl-icon', {
    attrs: {
      "type": "ion-ios-close-empty",
      "size": "30"
    },
    on: {
      "click": function($event) {
        _vm.$emit('input', '')
      }
    }
  })], 1), (_vm.icon) ? _c('span', {
    staticClass: "icon-wrap",
    on: {
      "click": function($event) {
        !_vm.disabled && _vm.$emit('click-icon')
      }
    }
  }, [_c('vbl-icon', {
    attrs: {
      "type": _vm.icon
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5c418ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblInput/src/vblInput.vue
// module id = 292
// module chunks = 0